import moment from "moment/moment";

export const updateObject = (oldObject, updatedProperties) => {
    return {
        ...oldObject,
        ...updatedProperties
    };
};

export const addMinutes = (baseDate, baseHour, minutes) => {
    const formatted_date = moment(baseDate).format("L")+" "+baseHour;
    const todays_date = moment(formatted_date, "DD.MM.YYYY HH:mm");
    return todays_date.add(minutes, 'minutes')
}


// WEBPACK FOOTER //
// ./src/store/utility.js